import { useAuthContext } from "@kalyzee/kast-web-sdk";
import { useEffect } from "react";
import { AppLoadingView } from "../utils/AppLoadingView";

/**
 * Guests have no home: their session is scoped to a meeting. When one lands
 * outside a meeting context (unknown routes, "back to meetings" fallbacks),
 * the guest session ends — back to the public login/lobby flow.
 */
const GuestFallbackRoute = () => {
  const { logout } = useAuthContext();

  useEffect(() => {
    // No `explicit_logout` here: this is a dead-end recovery, not a user
    // logout — let PublicRedirection capture a redirect if relevant.
    logout();
  }, [logout]);

  // Logging out flips the route tree on the next render; keep the app chrome
  // up until it commits.
  return <AppLoadingView />;
};

export default GuestFallbackRoute;
